import Utils from '../charts'

const DARK_COLOR = { from: 0.5, to: 0.85 }
const LIGHT_COLOR = { from: 0, to: 0.35 }

const createLinearGradient = (component, color, { from = 0.5, to = 0.85 }) => Utils
  .createLinearGradient(component, [
    Utils.color({ ...Utils.colorValue(color), a: to }),
    Utils.color({ ...Utils.colorValue(color), a: from })
  ])

export default [
  (component, { light } = { light: false }) => createLinearGradient(component, 'primary', light ? LIGHT_COLOR : DARK_COLOR),
  (component, { light } = { light: false }) => createLinearGradient(component, 'deep-orange lighten-1', light ? LIGHT_COLOR : DARK_COLOR),
  (component, { light } = { light: false }) => createLinearGradient(component, 'green darken-3', light ? LIGHT_COLOR : DARK_COLOR),
  (component, { light } = { light: false }) => createLinearGradient(component, 'red darken-3', light ? LIGHT_COLOR : DARK_COLOR)
]



// WEBPACK FOOTER //
// ./src/utils/chart-options/colors.js